/**
 * feature-config flag names owned by forms
 *
 * please consider removing this file and adding it to an appropriate place in the
 * feature code (e.g. an entrypoint, or a package owned by the feature team), or
 * passing flag names directly as a string!
 *
 * by separating it out, we decouple the feature code from the feature config packages
 * and avoid the need to update this package when flags are added or removed.
 */

export const FORMS_FLAG_NAMES = {
  // One gate per sending audience for moving form-notification email from
  // Mailjet to Postmark. Gate names keep the LIF-254 ticket prefix they were
  // created under.
  FREE_FORM_EMAIL_POSTMARK_ROLLOUT:
    'ff-lif-254-free-form-email-postmark-rollout',
  PAID_FORM_EMAIL_POSTMARK_ROLLOUT:
    'ff-lif-254-paid-form-email-postmark-rollout',
  WHITELABEL_FORM_EMAIL_POSTMARK_ROLLOUT:
    'ff-lif-254-whitelabel-form-email-postmark-rollout',
  // Kill switch for passing the form email sender as {name, address}.
  FORM_EMAIL_SENDER_ADDRESS_OBJECT:
    'ff-aeo-1937-form-email-sender-address-object',
} as const;
